module.exports = {
      id: "ic-marketbull-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-marketbull-usage",
      toString: function () {
        return this.url;
      }
    }